import { Flex, Text } from "@jsq/ds/core";
import * as styles from "~/pages/Compliance/InvestorCaseNavigation/InvestorCaseWizard/ReviewStep/styles_vanilla.css";
import { SummaryCard } from "~/pages/Compliance/InvestorCaseNavigation/InvestorCaseWizard/ReviewStep/SummaryCard";
import { assignedToLabel, displayOrEmpty } from "./utils";
import type { OnboardingCaseType, WizardCaseInfo } from "../types";

type Props = {
  caseInfo: WizardCaseInfo;
  caseType: OnboardingCaseType;
  onBack: () => void;
  onEdit?: () => void;
};

const Row = ({ label, value }: { label: string; value: string }) => (
  <Flex gap={20} alignItems="flex-start" className={styles.descriptionRow}>
    <Text asSpan variant="secondary-md" className={styles.descriptionLabel}>
      {label}
    </Text>
    <Text asSpan variant="regular-md" className={styles.descriptionValue}>
      {value}
    </Text>
  </Flex>
);

export const CaseInfoSummaryCard = ({ caseInfo, caseType, onBack, onEdit }: Props) => (
  <SummaryCard
    title="Case information"
    backLabel="Profile: Compliance profile"
    onBack={onBack}
    onEdit={onEdit}
  >
    <Flex flexDirection="column">
      <Row label="Client" value={displayOrEmpty(caseInfo.clientName)} />
      {caseType === "entity" && (
        <Row label="Entity" value={displayOrEmpty(caseInfo.entityName)} />
      )}
      <Row label="Assigned to" value={assignedToLabel(caseInfo.assignToMyself)} />
    </Flex>
  </SummaryCard>
);
